import React from 'react';
import { HiArrowRight } from 'react-icons/hi'
import { Link } from 'react-scroll';

const Home = () => {
  return (
    <div name='home' className='w-full h-screen bg-[#0a192f]'>
      {/* Container */}
      <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
        <p className='text-blue-200 text-3xl'>Hi, my name is</p>
        <h1 className='text-4xl sm:text-7xl font-bold text-[#ccd6f6]'>Mariam Owolabi</h1>
        <h2 className='text-4xl sm:text-7xl font-bold text-[#8892b0]'>I'm a FrontEnd Developer.</h2> 
        <p className='text-[#8892b0] py-4 max-w-[700px]'>I build highly responsive and interactive softwares with 
          great user interface that improves user experience.</p>
        <div>
          <Link to= 'projects'><button 
            className='text-white group border-2 px-6 py-3 my-2 
            flex items-center hover:px-[30px] hover:bg-blue-700 
            hover:border-bg-blue-700 duration-500'>
              View Projects 
          <span className='group-hover:rotate-90 duration-300'><HiArrowRight className='ml-3' /></span>
          </button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Home
